import { H3 } from "common/components/Typography";
import React from "react";

interface Props {
  title?: string;
  withUnderline?: boolean;
  withMargin?: boolean;
  className?: string;
}

export const Section: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  withMargin = true,
  className,
  children,
}) => {
  const margin = withMargin ? "1.5rem" : "";
  return (
    <section style={{ width: "100%", marginTop: margin }} className={className}>
      {title && <H3>{title}</H3>}
      {children}
    </section>
  );
};
